import { z } from 'zod';

/**
 * Leads partenaire — « fiches client » qu'un partenaire transmet à BCL
 * (cf. Module Commande d'Intervention Partenaire). BCL prend le lead en charge
 * puis le convertit en dossier standard (seul BCL planifie l'intervention :
 * agrément ARCEP).
 */

export const leadNeedTypeSchema = z.enum([
  'previsite_technique',
  'chiffrage_travaux',
  'remise_conformite',
  'remise_en_etat',
  'etude_raccordement',
  'precablage_telecom',
  'accompagnement_raccordement',
  'autre',
]);
export type LeadNeedType = z.infer<typeof leadNeedTypeSchema>;

export const leadStatusSchema = z.enum([
  'recue',
  'prise_en_charge',
  'convertie',
  'rejetee',
]);
export type LeadStatus = z.infer<typeof leadStatusSchema>;

const phoneRegex = /^[+0-9 ().-]{6,20}$/;

export const createLeadSchema = z.object({
  clientFirstName: z.string().trim().min(1).max(80),
  clientLastName: z.string().trim().min(1).max(80),
  clientPhone: z.string().trim().regex(phoneRegex),
  clientEmail: z.string().trim().toLowerCase().email(),
  addressLine: z.string().trim().min(1).max(200),
  postalCode: z.string().trim().min(4).max(10),
  city: z.string().trim().min(1).max(120),
  needType: leadNeedTypeSchema,
  comment: z.string().trim().max(2000).optional(),
});
export type CreateLeadInput = z.infer<typeof createLeadSchema>;

export const rejectLeadSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});
export type RejectLeadInput = z.infer<typeof rejectLeadSchema>;

export const leadSchema = z.object({
  id: z.string().uuid(),
  partnerId: z.string().uuid(),
  clientFirstName: z.string(),
  clientLastName: z.string(),
  clientPhone: z.string(),
  clientEmail: z.string(),
  addressLine: z.string(),
  postalCode: z.string(),
  city: z.string(),
  needType: leadNeedTypeSchema,
  comment: z.string().nullable(),
  status: leadStatusSchema,
  rejectionReason: z.string().nullable(),
  projectId: z.string().uuid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Lead = z.infer<typeof leadSchema>;
